import {
    ApiDailyRewardGrantSchema,
    ApiDailyRewardSnapshotSchema,
    ApiSmStateSnapshotSchema,
} from "@bridge-applications/pb-types";
import { z } from "zod";

export const DailyRewardSliceSchema = z.object({
    snapshot: ApiDailyRewardSnapshotSchema.nullable(),
    grants: z.array(ApiDailyRewardGrantSchema),
    loadStatus: z.enum(["idle", "loading", "ready", "error"]),
    loadError: z.string().nullable(),
    isDialogOpen: z.boolean(),
    claimState: z.enum(["idle", "claimable", "claimed"]),
    pendingSlotSnapshot: ApiSmStateSnapshotSchema.nullable(),
});

export type DailyRewardSlice = z.infer<typeof DailyRewardSliceSchema>;
